"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function ModelAndViewFromJSON(json) {
    return ModelAndViewFromJSONTyped(json, false);
}
exports.ModelAndViewFromJSON = ModelAndViewFromJSON;
function ModelAndViewFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'empty': !runtime_1.exists(json, 'empty') ? undefined : json['empty'],
        'model': !runtime_1.exists(json, 'model') ? undefined : json['model'],
        'modelMap': !runtime_1.exists(json, 'modelMap') ? undefined : json['modelMap'],
        'reference': !runtime_1.exists(json, 'reference') ? undefined : json['reference'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'view': !runtime_1.exists(json, 'view') ? undefined : _1.ViewFromJSON(json['view']),
        'viewName': !runtime_1.exists(json, 'viewName') ? undefined : json['viewName'],
    };
}
exports.ModelAndViewFromJSONTyped = ModelAndViewFromJSONTyped;
function ModelAndViewToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'empty': value.empty,
        'model': value.model,
        'modelMap': value.modelMap,
        'reference': value.reference,
        'status': value.status,
        'view': _1.ViewToJSON(value.view),
        'viewName': value.viewName,
    };
}
exports.ModelAndViewToJSON = ModelAndViewToJSON;
/**
* @export
* @enum {string}
*/
var ModelAndViewStatusEnum;
(function (ModelAndViewStatusEnum) {
    ModelAndViewStatusEnum["_100CONTINUE"] = "100 CONTINUE";
    ModelAndViewStatusEnum["_101SWITCHINGPROTOCOLS"] = "101 SWITCHING_PROTOCOLS";
    ModelAndViewStatusEnum["_102PROCESSING"] = "102 PROCESSING";
    ModelAndViewStatusEnum["_103CHECKPOINT"] = "103 CHECKPOINT";
    ModelAndViewStatusEnum["_200OK"] = "200 OK";
    ModelAndViewStatusEnum["_201CREATED"] = "201 CREATED";
    ModelAndViewStatusEnum["_202ACCEPTED"] = "202 ACCEPTED";
    ModelAndViewStatusEnum["_203NONAUTHORITATIVEINFORMATION"] = "203 NON_AUTHORITATIVE_INFORMATION";
    ModelAndViewStatusEnum["_204NOCONTENT"] = "204 NO_CONTENT";
    ModelAndViewStatusEnum["_205RESETCONTENT"] = "205 RESET_CONTENT";
    ModelAndViewStatusEnum["_206PARTIALCONTENT"] = "206 PARTIAL_CONTENT";
    ModelAndViewStatusEnum["_207MULTISTATUS"] = "207 MULTI_STATUS";
    ModelAndViewStatusEnum["_208ALREADYREPORTED"] = "208 ALREADY_REPORTED";
    ModelAndViewStatusEnum["_226IMUSED"] = "226 IM_USED";
    ModelAndViewStatusEnum["_300MULTIPLECHOICES"] = "300 MULTIPLE_CHOICES";
    ModelAndViewStatusEnum["_301MOVEDPERMANENTLY"] = "301 MOVED_PERMANENTLY";
    ModelAndViewStatusEnum["_302FOUND"] = "302 FOUND";
    ModelAndViewStatusEnum["_302MOVEDTEMPORARILY"] = "302 MOVED_TEMPORARILY";
    ModelAndViewStatusEnum["_303SEEOTHER"] = "303 SEE_OTHER";
    ModelAndViewStatusEnum["_304NOTMODIFIED"] = "304 NOT_MODIFIED";
    ModelAndViewStatusEnum["_305USEPROXY"] = "305 USE_PROXY";
    ModelAndViewStatusEnum["_307TEMPORARYREDIRECT"] = "307 TEMPORARY_REDIRECT";
    ModelAndViewStatusEnum["_308PERMANENTREDIRECT"] = "308 PERMANENT_REDIRECT";
    ModelAndViewStatusEnum["_400BADREQUEST"] = "400 BAD_REQUEST";
    ModelAndViewStatusEnum["_401UNAUTHORIZED"] = "401 UNAUTHORIZED";
    ModelAndViewStatusEnum["_402PAYMENTREQUIRED"] = "402 PAYMENT_REQUIRED";
    ModelAndViewStatusEnum["_403FORBIDDEN"] = "403 FORBIDDEN";
    ModelAndViewStatusEnum["_404NOTFOUND"] = "404 NOT_FOUND";
    ModelAndViewStatusEnum["_405METHODNOTALLOWED"] = "405 METHOD_NOT_ALLOWED";
    ModelAndViewStatusEnum["_406NOTACCEPTABLE"] = "406 NOT_ACCEPTABLE";
    ModelAndViewStatusEnum["_407PROXYAUTHENTICATIONREQUIRED"] = "407 PROXY_AUTHENTICATION_REQUIRED";
    ModelAndViewStatusEnum["_408REQUESTTIMEOUT"] = "408 REQUEST_TIMEOUT";
    ModelAndViewStatusEnum["_409CONFLICT"] = "409 CONFLICT";
    ModelAndViewStatusEnum["_410GONE"] = "410 GONE";
    ModelAndViewStatusEnum["_411LENGTHREQUIRED"] = "411 LENGTH_REQUIRED";
    ModelAndViewStatusEnum["_412PRECONDITIONFAILED"] = "412 PRECONDITION_FAILED";
    ModelAndViewStatusEnum["_413PAYLOADTOOLARGE"] = "413 PAYLOAD_TOO_LARGE";
    ModelAndViewStatusEnum["_413REQUESTENTITYTOOLARGE"] = "413 REQUEST_ENTITY_TOO_LARGE";
    ModelAndViewStatusEnum["_414URITOOLONG"] = "414 URI_TOO_LONG";
    ModelAndViewStatusEnum["_414REQUESTURITOOLONG"] = "414 REQUEST_URI_TOO_LONG";
    ModelAndViewStatusEnum["_415UNSUPPORTEDMEDIATYPE"] = "415 UNSUPPORTED_MEDIA_TYPE";
    ModelAndViewStatusEnum["_416REQUESTEDRANGENOTSATISFIABLE"] = "416 REQUESTED_RANGE_NOT_SATISFIABLE";
    ModelAndViewStatusEnum["_417EXPECTATIONFAILED"] = "417 EXPECTATION_FAILED";
    ModelAndViewStatusEnum["_418IAMATEAPOT"] = "418 I_AM_A_TEAPOT";
    ModelAndViewStatusEnum["_419INSUFFICIENTSPACEONRESOURCE"] = "419 INSUFFICIENT_SPACE_ON_RESOURCE";
    ModelAndViewStatusEnum["_420METHODFAILURE"] = "420 METHOD_FAILURE";
    ModelAndViewStatusEnum["_421DESTINATIONLOCKED"] = "421 DESTINATION_LOCKED";
    ModelAndViewStatusEnum["_422UNPROCESSABLEENTITY"] = "422 UNPROCESSABLE_ENTITY";
    ModelAndViewStatusEnum["_423LOCKED"] = "423 LOCKED";
    ModelAndViewStatusEnum["_424FAILEDDEPENDENCY"] = "424 FAILED_DEPENDENCY";
    ModelAndViewStatusEnum["_425TOOEARLY"] = "425 TOO_EARLY";
    ModelAndViewStatusEnum["_426UPGRADEREQUIRED"] = "426 UPGRADE_REQUIRED";
    ModelAndViewStatusEnum["_428PRECONDITIONREQUIRED"] = "428 PRECONDITION_REQUIRED";
    ModelAndViewStatusEnum["_429TOOMANYREQUESTS"] = "429 TOO_MANY_REQUESTS";
    ModelAndViewStatusEnum["_431REQUESTHEADERFIELDSTOOLARGE"] = "431 REQUEST_HEADER_FIELDS_TOO_LARGE";
    ModelAndViewStatusEnum["_451UNAVAILABLEFORLEGALREASONS"] = "451 UNAVAILABLE_FOR_LEGAL_REASONS";
    ModelAndViewStatusEnum["_500INTERNALSERVERERROR"] = "500 INTERNAL_SERVER_ERROR";
    ModelAndViewStatusEnum["_501NOTIMPLEMENTED"] = "501 NOT_IMPLEMENTED";
    ModelAndViewStatusEnum["_502BADGATEWAY"] = "502 BAD_GATEWAY";
    ModelAndViewStatusEnum["_503SERVICEUNAVAILABLE"] = "503 SERVICE_UNAVAILABLE";
    ModelAndViewStatusEnum["_504GATEWAYTIMEOUT"] = "504 GATEWAY_TIMEOUT";
    ModelAndViewStatusEnum["_505HTTPVERSIONNOTSUPPORTED"] = "505 HTTP_VERSION_NOT_SUPPORTED";
    ModelAndViewStatusEnum["_506VARIANTALSONEGOTIATES"] = "506 VARIANT_ALSO_NEGOTIATES";
    ModelAndViewStatusEnum["_507INSUFFICIENTSTORAGE"] = "507 INSUFFICIENT_STORAGE";
    ModelAndViewStatusEnum["_508LOOPDETECTED"] = "508 LOOP_DETECTED";
    ModelAndViewStatusEnum["_509BANDWIDTHLIMITEXCEEDED"] = "509 BANDWIDTH_LIMIT_EXCEEDED";
    ModelAndViewStatusEnum["_510NOTEXTENDED"] = "510 NOT_EXTENDED";
    ModelAndViewStatusEnum["_511NETWORKAUTHENTICATIONREQUIRED"] = "511 NETWORK_AUTHENTICATION_REQUIRED";
})(ModelAndViewStatusEnum = exports.ModelAndViewStatusEnum || (exports.ModelAndViewStatusEnum = {}));
